import {useEffect, useRef} from 'react';
import {useWebsocket} from 'context/websocket';
import {CreateEsimOrderRequestPayload, WS_EVENT_TYPES} from '@chekin/api';

const REJECT_TIMEOUT = 10000;

export const useEsimPaymentsCreatedListener = () => {
  const websocket = useWebsocket();
  const counterRef = useRef<number>(0);
  const resolveRef = useRef<(value?: unknown) => void>(() => {});
  const rejectRef = useRef<(value?: unknown) => void>(() => {});

  useEffect(() => {
    const message = websocket.message;

    if (WS_EVENT_TYPES.airaloPaymentsCreated === message?.event_type) {
      --counterRef.current;
      if (counterRef.current === 0) {
        resolveRef.current();
      }
    }

    return () => {
      websocket.clearMessage();
    };
  }, [websocket]);

  return {
    waitForPaymentsCreated: async (payload: CreateEsimOrderRequestPayload[]) => {
      rejectRef?.current();
      counterRef.current = payload.length;

      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error('Esim payments not created. Timeout error.'));
        }, REJECT_TIMEOUT);

        rejectRef.current = () => {
          reject();
          clearTimeout(timeout);
        };
        resolveRef.current = () => {
          resolve(true);
          clearTimeout(timeout);
        };
      });
    },
  };
};
